<template>
  <div class="dialog-wrap">
    <el-dialog title="调剂信息详情编辑"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               :append-to-body="true"
               width="731px">
      <div class="content">
        <div class="modular">
          <div class="title">
            <div class="line"></div>
            <div class="text">基本信息</div>
          </div>
          <div class="padding">
            <el-form class="search-wrap"
                     ref="formRules"
                     :model="dataForm"
                     :rules="rules"
                     label-width="100px"
                     label-position="left">
              <el-form-item label="考研年份："
                            prop="year">
                <el-select v-model="dataForm.year"
                           filterable
                           placeholder="请选择"
                           clearable
                           style="width: 100%">
                  <el-option v-for="(item, index) in filter.years"
                             :key="index"
                             :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="院校名称："
                            prop="college">
                <el-select v-model="dataForm.college"
                           filterable
                           placeholder="请选择"
                           @change="collegeChange"
                           style="width: 100%"
                           clearable>
                  <el-option v-for="(item, index) in $store.state.collegeList"
                             :key="index"
                             :label="item.name"
                             :value="{ value: item.code, label: item.name }">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="专业名称："
                            prop="major">
                <el-select v-model="dataForm.major"
                           placeholder="请选择"
                           filterable
                           clearable
                           @change="majorChange"
                           style="width: 100%">
                  <el-option v-for="(item, index) in majorList"
                             :key="index"
                             :label="item.name"
                             :value="{ value: item.code, label: item.name }">
                    <span>{{ `（${item.code}）${item.name}` }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="学院名称："
                            prop="academy">
                <el-select v-model="dataForm.academy"
                           placeholder="请选择"
                           filterable
                           clearable
                           style="width: 100%"
                           @change="academyChange">
                  <el-option v-for="(item, index) in academylist"
                             :key="index"
                             :label="item.academy_name"
                             :value="{
                      value: item.academy_code,
                      label: item.academy_name,
                      directions: item.directions,
                    }">
                    <span>{{
                      `（${item.academy_code}）${item.academy_name}`
                    }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="方向名称："
                            prop="direction">
                <el-select v-model="dataForm.direction"
                           placeholder="请选择"
                           filterable
                           style="width: 100%"
                           clearable>
                  <el-option v-for="(item, index) in directionlist"
                             :key="index"
                             :label="item.direction"
                             :value="{
                      value: item.direction_code,
                      label: item.direction,
                    }">
                    <span>{{
                      `（${item.direction_code}）${item.direction}`
                    }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="学习方式："
                            prop="enrol_type">
                <el-select v-model="dataForm.enrol_type"
                           filterable
                           placeholder="请选择"
                           clearable
                           style="width: 100%">
                  <el-option v-for="(item, index) in filter.enrol_types"
                             :key="index"
                             :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="调剂余额："
                            prop="plan_last_count">
                <div class="between">
                  <el-select v-model="dataForm.plan_last_count"
                             filterable
                             placeholder="请选择"
                             style="width: 60%"
                             clearable
                             v-if="plan_last_count_switch == 1">
                    <el-option label="有"
                               value="有"> </el-option>
                    <el-option label="无"
                               value="无"> </el-option>
                  </el-select>
                  <el-input-number v-model="dataForm.plan_last_count"
                                   :min="0"
                                   v-if="plan_last_count_switch == 0"
                                   label="描述文字"></el-input-number>
                  <el-switch v-model="plan_last_count_switch"
                             active-text="有无"
                             inactive-text="人数"
                             :active-value="1"
                             :inactive-value="0"
                             @change="switchChange">
                  </el-switch>
                </div>
              </el-form-item>

              <el-form-item label="上下线状态："
                            prop="adjust_demand">
                <el-switch v-model="dataForm._delete"
                           :active-value="0"
                           :inactive-value="2"
                           active-color="#13ce66"
                           inactive-color="#ff4949">
                </el-switch>
              </el-form-item>

              <el-form-item label="调剂要求："
                            prop="adjust_demand">
                <el-input style="
                    width: 100%;
                    white-space: pre-wrap;
                    word-break: break-all;
                  "
                          type="textarea"
                          :rows="8"
                          placeholder="请输入调剂余额"
                          v-model="dataForm.adjust_demand">
                </el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="modular"
             v-if="college_major_adjust_target">
          <div class="title">
            <div class="line"></div>
            <div class="text">调剂去向</div>
          </div>
          <div class="padding">
            <TargetTable :data="college_major_adjust_target"></TargetTable>
          </div>
        </div>
        <div class="modular"
             style="margin-top: 32px"
             v-if="college_major_adjust_source">
          <div class="title">
            <div class="line"></div>
            <div class="text">调剂来源</div>
          </div>
          <div class="padding">
            <SourceTable :data="college_major_adjust_source"></SourceTable>
          </div>
        </div>
        <div class="modular"
             style="margin-top: 32px"
             v-if="arr_college_score_line && arr_college_score_line.length">
          <div class="title">
            <div class="line"></div>
            <div class="text">历年分数</div>
          </div>
          <div class="padding">
            <ScoreLineTable :data="arr_college_score_line"></ScoreLineTable>
          </div>
        </div>
        <div class="modular"
             style="margin-top: 32px">
          <div class="title">
            <div class="line"></div>
            <div class="text">考试科目</div>
          </div>
          <div class="padding">
            <el-form class="dash-wrap"
                     label-width="90px"
                     label-position="left"
                     v-for="(item, index) in subjects"
                     :key="index">
              <el-form-item label="政治综合："
                            v-if="item[0]">
                <el-input placeholder=""
                          style="width: 100%"
                          readonly
                          v-model="item[0]">
                </el-input>
              </el-form-item>
              <el-form-item label="外语："
                            v-if="item[1]">
                <el-input placeholder=""
                          style="width: 100%"
                          readonly
                          v-model="item[1]">
                </el-input>
              </el-form-item>
              <el-form-item label="业务课一："
                            v-if="item[2]">
                <el-input placeholder=""
                          style="width: 100%"
                          readonly
                          v-model="item[2]">
                </el-input>
              </el-form-item>
              <el-form-item label="业务课二："
                            v-if="item[3]">
                <el-input placeholder=""
                          style="width: 100%"
                          readonly
                          v-model="item[3]">
                </el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="modular"
             style="margin-top: 32px">
          <div class="title">
            <div class="line"></div>
            <div class="text">联系方式</div>
          </div>
          <div class="padding">
            <el-form label-width="110px"
                     label-position="left">
              <el-form-item label="电话：">
                <el-input placeholder=""
                          style="width: 100%"
                          readonly
                          v-model="concat.contact_phone">
                </el-input>
              </el-form-item>
              <el-form-item label="邮箱：">
                <el-input placeholder=""
                          style="width: 100%"
                          readonly
                          v-model="concat.contact_email">
                </el-input>
              </el-form-item>
              <el-form-item label="地址：">
                <el-input placeholder=""
                          style="width: 100%"
                          readonly
                          v-model="concat.contact_address">
                </el-input>
              </el-form-item>
              <el-form-item label="研招办网址：">
                <el-input placeholder=""
                          style="width: 100%"
                          readonly
                          v-model="concat.contact_enrol_website">
                </el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <div class="modular"
             style="margin-top: 32px">
          <div class="title">
            <div class="line"></div>
            <div class="text">参考书目</div>
          </div>
          <div class="padding">
            <el-form label-width="90px"
                     label-position="left">
              <el-form-item label="参考书目：">
                <div class=""
                     v-html="reference_books"></div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div slot="footer"
           class="footer">
        <el-button @click="handleClose()">取消</el-button>
        <el-button type="primary"
                   @click="submit('formRules')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
      
<script>
import {
  collegeMajorList,
  majorSubjectList,
  academyList,
  majorinfo,
} from '@/api/common'
import { bulksingleCollege, adjustAdmin, adjustAdminEdit } from '@/api/adjust'
import SourceTable from '@/components/dialog/adjust/SourceTable.vue'
import TargetTable from '@/components/dialog/adjust/TargetTable.vue'
import ScoreLineTable from '@/components/dialog/adjust/ScoreLineTable.vue'

export default {
  components: {
    SourceTable,
    TargetTable,
    ScoreLineTable,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: {},
      rules: {},
      filter: {
        years: [
          { label: '2027年考研', value: 2027 },
          { label: '2026年考研', value: 2026 },
          { label: '2025年考研', value: 2025 },
          { label: '2024年考研', value: 2024 },
          { label: '2023年考研', value: 2023 },
        ],
        enrol_types: [
          { label: '全日制', value: 1 },
          { label: '非全日制', value: 2 },
        ],
      },
      majorList: [],
      academylist: [],
      directionlist: [],
      plan_last_count_switch: 1,
      college_major_adjust_source: '',
      college_major_adjust_target: '',
      arr_college_score_line: [],
      subjects: [],
      reference_books: '',
      concat: {},
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.dataForm = {}
        this.fetchDetail()
      }
    },
  },
  created() {},
  methods: {
    fetchDetail() {
      adjustAdmin({ id: this.id }).then((res) => {
        this.college_major_adjust_source = res.college_major_adjust_source
        this.college_major_adjust_target = res.college_major_adjust_target
        this.arr_college_score_line = res.arr_college_score_line
        this.$set(this.dataForm, 'year', Number(res.year))
        this.$set(this.dataForm, '_delete', res._delete)
        this.$set(this.dataForm, 'college', {
          label: res.college_name,
          value: res.college_code,
        })
        this.fetchMajor(res.college_code)
        this.$set(this.dataForm, 'major', {
          label: res.major_name,
          value: res.major_code,
        })
        this.fetchMajorInfo(res.college_code, res.major_code)
        this.$set(this.dataForm, 'academy', {
          label: res.academy_name,
          value: res.academy_code,
        })
        setTimeout(() => {
          this.directionlist = this.academylist.find((v) => {
            return (v.academy_code = res.academy_code)
          }).directions
          console.log(this.dataForm)
        }, 500)
        this.$set(this.dataForm, 'direction', {
          label: res.direction_name,
          value: res.direction_code,
        })
        this.$set(this.dataForm, 'enrol_type', res.enrol_type)
        if (res.plan_last_count == '有' || res.plan_last_count == '无') {
          this.plan_last_count_switch = 1
        } else {
          this.plan_last_count_switch = 0
        }
        this.$set(this.dataForm, 'plan_last_count', res.plan_last_count)
        this.$set(this.dataForm, 'adjust_demand', res.adjust_demand)
        this.subjects = JSON.parse(res.subjects)
        this.reference_books =
          res.reference_books && res.reference_books != 'null'
            ? res.reference_books
            : ''
        this.$set(this.concat, 'contact_phone', res.contact_phone)
        this.$set(this.concat, 'contact_email', res.contact_email)
        this.$set(this.concat, 'contact_address', res.contact_address)
        this.$set(
          this.concat,
          'contact_enrol_website',
          res.contact_enrol_website
        )

        this.$forceUpdate()
      })
    },
    // 录取院校选择后还要搜索相对应的院校名称
    collegeChange(e) {
      this.fetchMajor(e.value)
    },
    fetchMajor(college_code) {
      collegeMajorList({ college_code, isPaging: 0 }).then((res) => {
        this.majorList = res.list
      })
    },
    fetchAcademy(college_code, major_code) {
      academyList({ college_code, major_code, isPaging: 0 }).then((res) => {
        this.academylist = res.list
      })
    },
    majorChange(e) {
      this.fetchMajorInfo(this.dataForm.college.value, e.value)
    },
    fetchMajorInfo(college_code, major_code) {
      majorinfo({ college_code, major_code, isPaging: 0 }).then((res) => {
        this.academylist = res.academys
      })
    },
    academyChange(e) {
      this.directionlist = e.directions
    },
    switchChange(e) {
      if (e == 0) {
        this.$set(this.dataForm, 'plan_last_count', 1)
      } else if (e == 1) {
        this.$set(this.dataForm, 'plan_last_count', '')
      }
    },
    handleClose() {
      this.$emit('close')
    },

    submit(rules) {
      this.$refs[rules].validate((valid) => {
        if (valid) {
          const data = {
            id: this.id,
            college_name: this.dataForm.college.label,
            college_code: this.dataForm.college.value,
            year: this.dataForm.year,
            academy_code: this.dataForm.academy.value,
            academy_name: this.dataForm.academy.label,
            major_code: this.dataForm.major.value,
            major_name: this.dataForm.major.label,
            direction_code: this.dataForm.direction.value,
            direction_name: this.dataForm.direction.label,
            enrol_type: this.dataForm.enrol_type,
            plan_last_count: this.dataForm.plan_last_count,
            adjust_demand: this.dataForm.adjust_demand,
            _delete: this.dataForm._delete,
          }
          adjustAdminEdit(data).then((res) => {
            this.handleClose()
            this.$emit('submit')
            this.$message.success('创建成功')
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
/deep/.el-dialog__body {
  padding: 16px 0px;
}
.between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.content {
  overflow-y: hidden;
  .modular {
    .title {
      display: flex;
      align-items: center;
      .line {
        width: 4px;
        height: 22px;
        background: #266fe8;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
      }
      .text {
        font-size: 16px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #303133;
        margin-left: 26px;
      }
    }
    .padding {
      padding: 16px 30px;
    }
  }
}
.dash-wrap {
  & + .dash-wrap {
    margin-top: 32px;
  }
  padding: 20px;
  padding-bottom: 0px;
  border: dashed 1px #999;
  border-radius: 4px;
}
</style>
      